<template>
  <div class="million-read-medal">
    <div class="million-read-medal-header">
      <div class="million-read-medal-header-bar">
      </div>
      <div class="million-read-medal-header-info">
        <div class="million-read-medal-header-name">我的勋章</div>
        <div class="million-read-medal-header-count">
          已获得<span>{{ render.medalCount }}</span>枚勋章
        </div>
      </div>
    </div>
    <div class="million-read-medal-container">
      <div v-if="upgradeMedal"
           class="million-read-medal-upgrade"
      >
        <div class="million-read-medal-upgrade-block-title">{{ upgradeMedal.title }}</div>
        <div class="million-read-medal-upgrade-list">
          <div class="million-read-medal-upgrade-item"
               v-for="(item, index) in upgradeMedal.list"
               :key="index"
               @click="handleClickUpgradeMedal(item.id)"
          >
            <ym-img class="cover"
                    :class="{ 'disabled': item.currLevel === 0 }"
                    :src="item.cover"
            />
            <div class="title">{{ item.title }}</div>
            <div class="progress">
              <div class="progress-line"></div>
              <div class="progress-active-line"
                   :style="progressWidth(item.maxLevel, item.currLevel)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="collectionMedal"
           class="million-read-medal-collection"
      >
        <div class="million-read-medal-collection-block-title">{{ collectionMedal.title }}</div>
        <div class="million-read-medal-collection-list">
          <div class="million-read-medal-collection-item"
               v-for="(item, index) in collectionMedal.list"
               :key="index"
               @click="handleClickCollectMedal(item.id)"
          >
            <ym-img class="cover"
                    :class="{ 'disabled': item.receivedTime === 0 }"
                    :src="item.cover"
            />
            <div class="title">{{ item.title }}</div>
            <div v-if="item.receivedTime !== 0"
                 class="received-time"
            >
              {{ item.receivedTime | formatTime('yyyy-MM-dd') }} 获得
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getMyMedal } from '@/services/million-read';
  import { addUnit } from '@/utils';

  export default {
    name: 'MillionReadMedal',
    metaInfo: {},
    data() {
      return {
        render: {
          medalCount: 0,
        },
        upgradeMedal: null,
        collectionMedal: null,
      };
    },
    methods: {
      async fetchData() {
        const data = await getMyMedal();
        this.render = data.render;
        this.upgradeMedal = data.upgradeMedal;
        this.collectionMedal = data.collectionMedal;
      },
      progressWidth(max, curr) {
        return `width: ${addUnit(120 / max * curr)}`;
      },
      handleClickCollectMedal(id) {
        this.$router.push({ name: 'MillionReadCollectionMedalDetail', params: { id } });
      },
      handleClickUpgradeMedal(id) {
        this.$router.push({ name: 'MillionReadUpgradeMedalDetail', params: { id } });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  .million-read-medal {
    min-height: 100%;
    background: @color-white;

    &-header {
      &-bar {
        box-sizing: border-box;
        width: 100%;
        height: 88px;
        padding-left: @size-base;
        background: #fed100;
      }

      &-info {
        box-sizing: border-box;
        width: 100%;
        height: 298px;
        padding: 72px 0 0 62px;
        background: url('~@/assets/img/million_read/medal_header.png');
        background-size: contain;
      }

      &-name {
        margin-bottom: 16px;
        color: @color-text-base;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-strong;
        line-height: 1;
      }

      &-count {
        box-sizing: border-box;
        width: fit-content;
        height: 40px;
        padding: 7px 16px;
        display: flex;
        align-items: center;
        color: @color-text-base;
        font-size: 26px;
        font-weight: @font-weight-strong;
        line-height: 1;
        background: linear-gradient(180deg, #fff5dd 0%, #ffe9c0 100%);
        box-shadow: 0 10px 20px 0px rgba(255, 190, 0, 0.5), 0 2px 5px 0px rgba(255, 255, 255, 0.5);
        border-radius: 23px;

        span {
          display: inline;
          margin: 0 @size-extra-small;
          color: #c97e08;
        }
      }
    }
    &-container {
      box-sizing: border-box;
      width: 100%;
      margin-top: -46px;
      padding-top: 60px;
      border-radius: 20px 0 0 0;
      background: @color-white;
    }
    &-upgrade,
    &-collection {
      &-block-title {
        margin-bottom: 46px;
        padding-left: @size-base;
        color: @color-text-base;
        font-size: @font-size-large;
        font-weight: @font-weight-strong;
      }
      &-list {
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
      }
      &-item {
        width: 250px;
        margin-bottom: @size-large;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .cover {
          margin-bottom: 16px;
          width: 160px;
          height: 160px;
          border-radius: 4px;
          overflow: hidden;
          &.disabled {
            filter: grayscale(100%);
          }
        }
        .title {
          margin-bottom: 12px;
          color: @color-text-base;
          font-size: 26px;
          line-height: 1;
          text-align: center;
        }
        .received-time {
          color: @color-text-lighter;
          font-size: 20px;
          line-height: 1;
        }
      }
    }
    &-upgrade {
      margin-bottom: @size-base;
      &-item {
        .progress {
          position: relative;
          height: 14px;
          display: flex;
          align-items: center;
        }
        .progress-line {
          width: 120px;
          height: 8px;
          content: '';
          background: #f5f6fa;
          border-radius: 3px;
        }
        .progress-active-line {
          position: absolute;
          top: 0;
          left: 0;
          height: 14px;
          content: '';
          background: #fed100;
          border-radius: 7px;
        }
      }
    }
  }

</style>
